<template>
  <div class="appointment-page">
    <div class="activity-container">
      <img 
        src="/images/activity-bg.jpg"
        alt="活动介绍" 
        class="activity-bg"
      >
    </div>
    
    <!-- 红色一键预约按钮 -->
    <div class="appointment-button-container">
      <van-button 
        round 
        size="large"
        class="appointment-button"
        @click="handleAppointmentClick"
        :loading="loading"
      >
        {{ loading ? '处理中...' : '一键预约' }}
      </van-button>
    </div>
    
    <!-- 预约表单弹窗 -->
    <AppointmentForm 
      v-model:show="showForm"
      :amount="paymentAmount"
    />
  </div>
</template>

<script>
import { Button } from 'vant'
import { showConfirmDialog, showToast } from 'vant'
import AppointmentForm from '../components/AppointmentForm.vue'
import request from '../utils/request'

export default {
  name: 'AppointmentPage',
  components: {
    AppointmentForm,
    [Button.name]: Button
  },
  data() {
    return {
      showForm: false,
      loading: false,
      paymentAmount: process.env.VUE_APP_PAYMENT_AMOUNT || 99,
      isAuthenticated: false
    }
  },
  async created() {
    // 页面加载时检查用户是否已授权
    this.checkAuthentication()
  },
  methods: {
    async checkAuthentication() {
      try {
        const response = await request.get('/wechat/check-auth')
        
        if (response?.data?.authenticated) {
          this.isAuthenticated = true
          console.log('用户已授权')
        } else {
          console.log('用户未授权，需要微信授权')
          // 直接跳转到后端静默授权接口
          this.redirectToWechatAuth()  
        }
      } catch (error) {
        console.error('检查授权状态失败:', error)
        showToast('系统初始化失败，请刷新页面重试')
      }
    },

    async handleAppointmentClick() {
      console.log('点击一键预约')
      
      // 检查是否在 PC 微信
      if (this.isPcWechatBrowser()) {
        try {
          await showConfirmDialog({
            title: '环境限制',
            message: '请在手机微信中预约活动',
            confirmButtonText: '知道了',
            showCancelButton: false
          })
        } catch {}
        return
      }

      // 检查是否在微信环境
      if (!this.isWechatBrowser()) {
        try {
          await showConfirmDialog({
            title: '环境限制',
            message: '请在微信客户端中打开此页面完成预约支付',
            confirmButtonText: '知道了',
            showCancelButton: false
          })
        } catch {}
        return
      }

      if (!this.isAuthenticated) {
        // 如果未授权，跳转授权
        this.redirectToWechatAuth()  
        return
      }

      this.showForm = true
    },

    redirectToWechatAuth() {
      this.loading = true
      try {
        const currentUrl = encodeURIComponent(window.location.href)
        const authUrl = `${window.location.origin}/api/wechat/silent-auth?redirectUrl=${currentUrl}`
        window.location.href = authUrl
      } catch (error) {
        console.error('跳转微信授权失败:', error)
        showToast('获取微信授权异常，请稍后重试。')
      } finally {
        this.loading = false
      }
    },

    isWechatBrowser() {
      const ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },

    isPcWechatBrowser() {
      const ua = navigator.userAgent.toLowerCase()

      const isPcWechatKeyword = ua.includes('windowswechat') ||
                                ua.includes('macwechat') ||
                                ua.includes('pcwechat')

      const isWechat = this.isWechatBrowser()

      const isMobileOrTablet =
        /mobile|android|iphone|ipad|ipod|tablet/i.test(ua)

      return isPcWechatKeyword || (isWechat && !isMobileOrTablet)
    }
  }
}
</script>

<style scoped>
.appointment-page {
  position: relative;
  min-height: 100vh;
  padding-bottom: 80px;
  overflow-y: auto;
}

.activity-container {
  width: 100%;
}

.activity-bg {
  width: 100%;
  display: block;
  height: auto;
  min-height: 100vh;
}

/* 底部按钮容器 */
.appointment-button-container {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  padding: 0 20px;
  z-index: 10;
}

/* 红色按钮样式 */
.appointment-button {
  width: 100%;
  height: 55px;
  font-size: 18px;
  background-color: #ff3b30 !important;
  border-color: #ff3b30 !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(255, 59, 48, 0.4);
}

.appointment-button:active {
  background-color: #d42d22 !important;
  border-color: #d42d22 !important;
}
</style>
